<div class="media-container">
  <ds-tile>
    <img *ngIf="!isVideo" class="tile-image" src="{{ src }}" [alt]="alt" />
    <iframe
      *ngIf="isVideo"
      class="tile-video"
      [attr.src]="src | sanitizeUrl"
      allowfullscreen
      [title]="header"
    >
    </iframe>
    <div class="tile-header">
      <p class="header">
        {{ header }}
      </p>
      <p class="sub-header">
        {{ subHeader }}
      </p>
    </div>
  </ds-tile>
</div>
